import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAx0OxOzLDBtLn2Wl7s91Fv7fgwds7_VyM",
  authDomain: "cd-assist.firebaseapp.com",
  projectId: "cd-assist",
  storageBucket: "cd-assist.firebasestorage.app",
  messagingSenderId: "993051772659",
  appId: "1:993051772659:web:beacdc1bb29f62fe731986"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();